import styled, { css } from 'styled-components';

import { CommonAction, extCommonAction, recipesCommonAction, styledMedia, styledTypography } from '@pkg/primitives';

export const Wrapper = styled.div`
    display: grid;
    gap: 20px;
    padding-bottom: 20px;

    @media (min-width: 768px) {
        padding-top: 20px;
    }

    @media (min-width: 1280px) {
        display: flex;
        align-items: end;
        justify-content: space-between;
    }
`;

export const LeftSide = styled.div`
    display: grid;
    align-items: center;
    flex: 1 1 auto;

    @media (min-width: 768px) {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        max-width: 1280px;
        // Why do we need these position styles?
        position: relative;
        z-index: 8;
    }

    @media (min-width: 1280px) {
        flex-wrap: nowrap;
    }
`;

export const LiquidIdWrapper = styled.div`
    justify-self: start;
    flex: 0 0 auto;
`;

export const ContentHolder = styled.div`
    display: grid;
    gap: 16px;
    justify-items: start;
    flex: 1 1 auto;
    // Setting these sizes helps with restricting the child
    // <textarea /> inputs to a width range, as well as allowing
    // the ContentHolder to wrap alongside the LiquidId. Unfortunately,
    // A growing <textarea /> can force the wrap switching... so we may
    // want to revise this with container-queries in the future.
    min-width: 240px;
    max-width: 400px;

    @media (min-width: 1280px) {
        max-width: 540px;
    }
`;

export const YatRhythm = styled.div`
    display: grid;
    grid-auto-flow: column;
    align-items: center;
    gap: 8px;
`;

export const RhythmWrapper = styled.div`
    display: grid;
    grid-auto-flow: column;
    align-items: center;
    // 'font-size' is used to control the size of the <RhythmScoreBadge />.
    font-size: 32px;

    @media (min-width: 768px) {
        font-size: 40px;
    }
`;

export const RightSide = styled.div`
    display: flex;
    flex-direction: row-reverse;
    justify-content: start;
    gap: 10px;
    flex: 0 0 auto;

    @media (min-width: 768px) {
        // Why do we need these position styles?
        position: relative;
        z-index: 8;
        flex-direction: unset;
        justify-content: end;
    }

    @media (min-width: 1280px) {
        padding-bottom: 20px;
    }
`;

///
/// Actions

const actionExtension = css`
    gap: 6px;
    padding-left: 16px;
    padding-right: 16px;
    height: 32px;
`;

export const ActionIcon = styled.div`
    ${styledMedia.iconWrapper};
    z-index: 3;
    position: relative;
    width: 16px;
    height: 16px;
`;

export const ActionLabel = styled.span`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    z-index: 3;
    position: relative;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: -0.02em;
`;

export const SecondaryAction = styled(CommonAction)`
    ${recipesCommonAction.basic};
    ${actionExtension};
    background-color: rgb(255, 255, 255, 0.1);

    &:hover:not(:active) {
        background-color: rgb(255, 255, 255, 0.16);
    }
`;

export const ShareAction = styled(CommonAction)`
    ${recipesCommonAction.basic};
    ${extCommonAction.gradientPrimary};
    ${actionExtension};
`;

// TODO: Fix the `YatShareModule > customButton` implementation.
export const TempShareWrapper = styled.div``;
